/* ============================================================
   Maison Atelier Premium — cart-drawer.js
   Carrello AJAX (Section Rendering API) + quick add
   ============================================================ */
(function () {
  'use strict';
  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};
  var utils = (window.theme && window.theme.utils) || {};
  var SECTION = 'cart-drawer';

  var drawer = document.querySelector('[data-cart-drawer]');
  function beginLoader() {
    return window.theme.preloader ? window.theme.preloader.beginCart() : function () {};
  }

  function openCart() {
    if (drawer && window.theme.openPanel) window.theme.openPanel(drawer, 'is-open');
    loadCartRecommendations();
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function renderSections(sections) {
    if (!sections || !sections[SECTION]) return;
    var parsed = new DOMParser().parseFromString(sections[SECTION], 'text/html');
    var newContent = parsed.querySelector('[data-cart-drawer-content]');
    var oldContent = document.querySelector('[data-cart-drawer-content]');
    if (newContent && oldContent) oldContent.innerHTML = newContent.innerHTML;

    var newFooter = parsed.querySelector('[data-cart-footer]');
    var oldFooter = document.querySelector('[data-cart-footer]');
    if (oldFooter) oldFooter.remove();
    if (newFooter && drawer) drawer.appendChild(newFooter);

    // aggiorna contatori
    var count = parsed.querySelector('[data-cart-count]');
    var n = count ? parseInt(count.textContent, 10) || 0 : 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: { item_count: n } } }));
    loadCartRecommendations();
  }

  function mutate(url, body) {
    body.sections = [SECTION];
    body.sections_url = window.location.pathname;
    return postJSON(url, body).then(function (data) {
      renderSections(data.sections);
      return data;
    });
  }

  function loadCartRecommendations() {
    var holder = document.querySelector('[data-cart-related]');
    if (!holder || holder.hidden) return;

    var productId = holder.getAttribute('data-product-id');
    var target = holder.querySelector('[data-cart-related-target]');
    var endpoint = holder.getAttribute('data-url') || routes.recommendations || '/recommendations/products';
    var sectionId = holder.getAttribute('data-section-id') || SECTION;
    var limit = holder.getAttribute('data-limit') || '4';
    var intent = holder.getAttribute('data-intent') || 'related';
    if (!productId || !target || !endpoint) return;

    var requestKey = [productId, sectionId, limit, intent].join(':');
    if (holder.getAttribute('data-loaded-key') === requestKey) return;
    holder.setAttribute('data-loaded-key', requestKey);
    holder.classList.add('is-loading');

    var url = endpoint +
      '?section_id=' + encodeURIComponent(sectionId) +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(limit) +
      '&intent=' + encodeURIComponent(intent);

    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Recommendations unavailable');
        return r.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-related-target]');
        if (!fresh) return;

        var nextHtml = fresh.innerHTML.trim();
        if (!nextHtml) {
          holder.hidden = true;
          return;
        }

        target.innerHTML = fresh.innerHTML;
        holder.hidden = false;
      })
      .catch(function () {
        if (!target.innerHTML.trim()) holder.hidden = true;
      })
      .finally(function () {
        holder.classList.remove('is-loading');
      });
  }

  /* ---------- Add to cart (form prodotto + quick add singolo) ---------- */
  function addFromForm(form) {
    var formData = new FormData(form);
    var body = { items: [{ id: formData.get('id'), quantity: parseInt(formData.get('quantity') || '1', 10) }] };
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    var finishLoader = beginLoader();
    return mutate(routes.cartAdd, body)
      .then(function () { openCart(); })
      .catch(function () {})
      .finally(function () { finishLoader(); if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form], [data-quick-add-form], form.product-form');
    if (!form) return;
    e.preventDefault();
    addFromForm(form);
  });

  /* ---------- Quantità / rimozione ---------- */
  function changeLine(key, quantity) {
    return mutate(routes.cartChange, { id: key, quantity: quantity });
  }
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-key'), parseInt(input.value, 10) || 0);
  });
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.getAttribute('data-key'), 0); }
  });

  /* ---------- Gift wrap + note ---------- */
  document.addEventListener('change', function (e) {
    var gift = e.target.closest('[data-gift-wrap]');
    if (!gift) return;
    mutate(routes.cartUpdate, { attributes: { 'Confezione regalo': gift.checked ? 'Sì' : '' } });
  });
  var noteHandler = utils.debounce ? utils.debounce(function (val) {
    postJSON(routes.cartUpdate, { note: val });
  }, 600) : function () {};
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (note) noteHandler(note.value);
  });

  /* ---------- Quick add multivariante (mini drawer) ---------- */
  var qaDrawer = document.querySelector('[data-quick-add-drawer]');
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn || !qaDrawer) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-quick-add');
    btn.classList.add('is-loading');
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        buildQuickAdd(product);
        if (window.theme.openPanel) window.theme.openPanel(qaDrawer, 'is-open');
      })
      .catch(function () {})
      .finally(function () { btn.classList.remove('is-loading'); });
  });

  function buildQuickAdd(product) {
    var title = qaDrawer.querySelector('[data-quick-add-title]');
    var body = qaDrawer.querySelector('[data-quick-add-body]');
    if (title) title.textContent = product.title;
    if (!body) return;
    var html = '<div class="variant-values" role="group" aria-label="' + (strings.chooseSize || '') + '">';
    product.variants.forEach(function (v) {
      var disabled = v.available ? '' : 'disabled';
      var soldout = v.available ? '' : ' (' + (strings.soldOut || '') + ')';
      html += '<button type="button" class="button button--secondary" style="min-width:auto" data-qa-variant="' + v.id + '" ' + disabled + '>' + v.title + soldout + '</button>';
    });
    html += '</div>';
    body.innerHTML = html;
    body.querySelectorAll('[data-qa-variant]').forEach(function (b) {
      b.addEventListener('click', function () {
        var finishLoader = beginLoader();
        mutate(routes.cartAdd, { items: [{ id: b.getAttribute('data-qa-variant'), quantity: 1 }] })
          .then(function () {
            if (window.theme.closePanel) window.theme.closePanel(qaDrawer);
            openCart();
          })
          .catch(function () {})
          .finally(function () { finishLoader(); });
      });
    });
  }

  // espone l'add per product-form.js (Buy now / variant change non serve qui)
  window.theme.cart = { add: addFromForm, open: openCart, mutate: mutate };
  loadCartRecommendations();
})();
